import { lazy } from 'react';
import { useRoutes, Navigate } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import AuthGuard from 'utils/route-guard/AuthGuard';
import { BASE_PATH } from 'config';
import GuestGuard from 'utils/route-guard/GuestGuard';
import Register from 'views/auth/register';
import Login from 'views/auth/Login';
import ForgotPassword from 'views/auth/ForgotPassword';
import CreateUsers from "components/CreateUsers";
import InvitePage from 'views/InvitePage';
import ErrorPage from '../views/ErrorPage';
import Terms from 'views/terms';
import Landing from 'Landing';
// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([
    {
      path: '/',
      element: (
        <Landing />
        // <AuthGuard>
        //   <Navigate to="/dashboard" />
        // </AuthGuard>
      )
    },
    {
      path: '/terms',
      element: (
        <Terms />
      ),
    },
    {
      path: '/terms-of-service',
      element: (
        <Terms />
      ),
    },
    {
      path: '/invite/:invitationToken',
      element: (
        <GuestGuard>
          <Register />
        </GuestGuard>
      ),
    },
    {
      path: '/r/:invitationCode',
      element: (
        <GuestGuard>
          <InvitePage />
        </GuestGuard>
      ),
    },
    {
      path: '/register',
      element: (
        <GuestGuard>
          <Register />
        </GuestGuard>
      ),
    },
    {
      path: '/register/solo',
      element: (
        <GuestGuard>
          <Register plan="solo"/>
        </GuestGuard>
      ),
    },
    {
      path: '/register/business',
      element: (
        <GuestGuard>
          <Register plan="business"/>
        </GuestGuard>
      ),
    },
    {
      path: '/register/premium',
      element: (
        <GuestGuard>
          <Register plan="premium"/>
        </GuestGuard>
      ),
    },
    {
      path: '/login',
      element: (
        <GuestGuard>
          <Login />
        </GuestGuard>
      ),
    },
    {
      path: '/forgot-password',
      element: (
        <GuestGuard>
          <ForgotPassword />
        </GuestGuard>
      ),
    },
    {
      path: '/error',
      element: <ErrorPage />
    },
    MainRoutes,
  ]);
}
